import React, { useEffect, useState } from "react";
import styles from "./setpassword.module.scss";
import { Container, Label } from "./components/Inputs";
import Icon from "../../components/Icon";
import { ClipLoader } from "react-spinners";
import { useSearchParams } from "react-router-dom";
import { changePassword } from "../../features/Registration";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { passwordData } from "./type";

export const SetPassword = () => {
  const [searchParams] = useSearchParams();
  const [pass, updatePass] = useState<passwordData>({
    email: searchParams.get("email") || null,
    oldPassword: "",
    newPassword: "",
  });
  const [errorMsg, setError] = useState("");
  const [repeatPass, updateRepeatPass] = useState("");
  const [loading, updateLoading] = useState(false);

  const [visible, setVisible] = useState({
    temporaryPassword: false,
    newPassword: false,
    reEnterPassword: false,
  });

  const handlePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updatePass({ ...pass, [name]: value });
  };

  useEffect(() => {
    if (repeatPass !== "") {
      if (pass.newPassword !== repeatPass) {
        updateLoading(false);
      } else {
        updateLoading(true);
      }
    }
  }, [repeatPass]);

  const { mutateAsync: submitPassword, isPending: pending } = useMutation({
    mutationFn: changePassword,
    onError: (error) => {
      console.log(error);
      toast.error(error.message || "Password set failed", {
        richColors: true,
      });
    },
    onSuccess: (data) => {
      toast.success("Password set successfully", {
        richColors: true,
      });
    },
  });
  return (
    <div className={styles.body}>
      <div className={styles.action}>
        <div className={styles.header}>
          <h1>Password Update</h1>
          <p>create your password</p>
        </div>

        <form
          className={styles.formCase}
          onSubmit={(e) => {
            e.preventDefault();
            submitPassword(pass);
          }}
        >
          <Container>
            <Label htmlFor="temporaryPassword" title="Temporary Password" />
            <div className={styles.inputCase}>
              <input
                id="temporaryPassword"
                type={visible.temporaryPassword ? "text" : "password"}
                placeholder="Password"
                name="oldPassword"
                value={pass.oldPassword}
                onChange={handlePassword}
                className={styles.inputs}
                required={true}
              />
              <div
                onClick={() =>
                  setVisible({ ...visible, temporaryPassword: !visible.temporaryPassword })
                }
              >
                {visible?.temporaryPassword ? (
                  <Icon name="eyeSlash" height={25} width={25} />
                ) : (
                  <Icon name="eye" height={25} width={25} />
                )}
              </div>
            </div>
          </Container>

          <Container>
            <Label htmlFor="newPassword" title="New Password" />
            <div className={styles.inputCase}>
              <input
                id="newPassword"
                type={visible.newPassword ? "text" : "password"}
                placeholder="Password"
                name="newPassword"
                value={pass.newPassword}
                onChange={handlePassword}
                className={styles.inputs}
                required={true}
              />
              <div onClick={() => setVisible({ ...visible, newPassword: !visible.newPassword })}>
                {visible?.newPassword ? (
                  <Icon name="eyeSlash" height={25} width={25} />
                ) : (
                  <Icon name="eye" height={25} width={25} />
                )}
              </div>
            </div>
          </Container>

          <Container>
            <Label htmlFor="reEnterPassword" title=" Re-enter New Password" />
            <div
              className={repeatPass === "" || loading ? `${styles.inputCase}` : `${styles.noMatch}`}
            >
              <input
                id="reEnterPassword"
                type={visible.reEnterPassword ? "text" : "password"}
                placeholder="Password"
                name="repeatPassword"
                value={repeatPass}
                onChange={(e) => updateRepeatPass(e.target.value)}
                className={styles.inputs}
                required={true}
              />
              <div
                onClick={() =>
                  setVisible({ ...visible, reEnterPassword: !visible.reEnterPassword })
                }
              >
                {visible?.reEnterPassword ? (
                  <Icon name="eyeSlash" height={25} width={25} />
                ) : (
                  <Icon name="eye" height={25} width={25} />
                )}
              </div>
            </div>
            {repeatPass !== "" && !loading && (
              <p style={{ color: "red", margin: 0 }}>Passwords do not match </p>
            )}
          </Container>

          <div className="btnCont">
            <button className={styles.submit} type="submit" disabled={!loading} data-test="login">
              {pending ? <ClipLoader color="white" size={20} /> : " Create Password"}{" "}
            </button>
          </div>
        </form>
      </div>

      <div className={styles.imageWrapper}></div>
    </div>
  );
};
